import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject, Subject, Subscriber } from 'rxjs';
import { environment } from '../../environments/environment';
import { AddNewPost, Post } from '../interfaces/post.interface';
import { IFile } from '../interfaces/referral.interface';
declare const SockJS: any;
declare const Stomp: any;
@Injectable({
  providedIn: 'root'
})
export class SocketService {
  socket: any;
  stompClient: any = null;
  allPosts: Subject<any> = new BehaviorSubject('');
  allPostsSubscriptions: any[] = [];
  allDocuments: Subject<any> = new BehaviorSubject('');
  allDocumentsSubscriptions: any[] = [];
  $subscription = new Subscriber();
  spaceId: string = '';

  addPostSubscription: any;
  isSocketConnected: Subject<boolean> = new ReplaySubject(1);
  constructor() {
    //this.socketConnection();
  }

  socketConnection() {
    this.socket = new SockJS(environment.socket_api_url);
    this.stompClient = Stomp.over(this.socket);
    this.stompClient.connect({}, (frame: any) => {
      this.isSocketConnected.next(true);
    });

    this.socket.onclose = (event: CloseEvent) => {
      if (event.code === 1009) {
        this.isSocketConnected.next(false);
        this.socketConnection();
      }
    };
  }

  getAllPosts() {
    this.allPostsSubscriptions = [];
    this.stompClient.send(`/app/space/${this.spaceId}/posts`, {}, JSON.stringify(''));
    const allPostSubscription = this.stompClient.subscribe(`/topic/space/${this.spaceId}/posts`, (result: any) => {
      this.allPosts.next({ type: "allMessages", result });
    });

    const newPostSubscription = this.stompClient.subscribe(`/topic/space/${this.spaceId}/posts/post`, (result: any) => {
      this.allPosts.next({ type: "newMessage", result });
    });

    const editPostSubscription = this.stompClient.subscribe(`/topic/space/${this.spaceId}/posts/editPost`, (result: any) => {
      this.allPosts.next({ type: "editPost", result });
    });

    //comments
    // const newCommentSubscription = this.stompClient.subscribe(`/topic/space/${this.spaceId}/posts/comment`, (result: any) => {
    //   this.allPosts.next({ type: "newComments", result });
    // });

    // const editCommentSubscription = this.stompClient.subscribe(`/topic/space/${this.spaceId}/posts/editComment`, (result: any) => {
    //   this.allPosts.next({ type: "allMessages", result });
    // });

    this.allPostsSubscriptions = [allPostSubscription, newPostSubscription, editPostSubscription];

  }

  getAllDocuments() {
    this.allDocumentsSubscriptions = [];
    this.stompClient.send(`/app/space/${this.spaceId}/documents`, {}, JSON.stringify(''));
    const allDocumentsSubscription = this.stompClient.subscribe(`/topic/space/${this.spaceId}/documents`, (result: any) => {
      this.allDocuments.next({ type: "allDocuments", result });
    });
    this.allDocumentsSubscriptions = [allDocumentsSubscription];
  }

  addPostSocket(post: Post) {
    this.stompClient.send(`/app/space/${this.spaceId}/posts/post`, {},
      JSON.stringify(post));
  }

  editPost(post: Post) {
    this.stompClient.send(`/app/space/${this.spaceId}/posts/post/${post.postId}`, {},
      JSON.stringify(post));
  }

  addCommentSocket(postId: number, comment: Post) {
    this.stompClient.send(`/app/space/${this.spaceId}/posts/${postId}/comments`, {},
      JSON.stringify(comment));
  }
  
  editComment(postId: number, comment: Post) {
    this.stompClient.send(`/app/space/${this.spaceId}/posts/${postId}/comments/${comment.postId}`, {},
      JSON.stringify(comment));
  }

  unsubscribeFromTopics(subscription: any[]) {
    subscription.forEach((topic: any) => {
      topic.unsubscribe();
    })
  }

  // this method is used to end web socket connection
  disconnectSocket() {
    this.stompClient.disconnect(() => {
      // Disconnection success callback
      console.log('Disconnected from WebSocket');
    });
  }

  updateFile(file: any) {
    this.stompClient.send(`/app/space/${this.spaceId}/documents/${file.id}/updateDocument`, {},
      JSON.stringify(file));
  }
}
